import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { LanguageRouter } from "./components/LanguageRouter";
import { SeoMeta } from "./components/SeoMeta";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ServicesPage } from "./pages/ServicesPage";
import { BookingPage } from "./pages/BookingPage";
import { ContactPage } from "./pages/ContactPage";
import { CityTransfersPage } from "./pages/CityTransfersPage";
import {
  GiethoornPage,
  BrugesPage,
  KeukenhofPage,
  MarkenPage,
  VolendamPage,
  ZaanseSchansPage,
  BrusselsPage,
  AntwerpPage,
} from "./pages/tours";
import {
  BookingModalProvider,
  useBookingModal,
} from "./contexts/BookingModalContext";
import BookingModal from "./components/BookingModal";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const { isModalOpen, closeModal } = useBookingModal();

  return (
    <div className="min-h-screen bg-gray-900">
      <SeoMeta />
      <Navigation />
      <Routes>
        {/* English Routes */}
        <Route path="/en" element={<HomePage />} />
        <Route path="/en/about" element={<AboutPage />} />
        <Route path="/en/services" element={<ServicesPage />} />
        <Route path="/en/booking" element={<BookingPage />} />
        <Route path="/en/contact" element={<ContactPage />} />
        <Route path="/en/city-transfers" element={<CityTransfersPage />} />

        {/* English Tour Routes */}
        <Route path="/en/tours/giethoorn" element={<GiethoornPage />} />
        <Route path="/en/tours/bruges" element={<BrugesPage />} />
        <Route path="/en/tours/keukenhof" element={<KeukenhofPage />} />
        <Route path="/en/tours/marken" element={<MarkenPage />} />
        <Route path="/en/tours/volendam" element={<VolendamPage />} />
        <Route path="/en/tours/zaanse-schans" element={<ZaanseSchansPage />} />
        <Route path="/en/tours/brussels" element={<BrusselsPage />} />
        <Route path="/en/tours/antwerp" element={<AntwerpPage />} />

        {/* Dutch Routes */}
        <Route path="/nl" element={<HomePage />} />
        <Route path="/nl/over-ons" element={<AboutPage />} />
        <Route path="/nl/diensten" element={<ServicesPage />} />
        <Route path="/nl/boeken" element={<BookingPage />} />
        <Route path="/nl/contact" element={<ContactPage />} />
        <Route path="/nl/stad-transfers" element={<CityTransfersPage />} />

        {/* Dutch Tour Routes */}
        <Route path="/nl/tours/giethoorn" element={<GiethoornPage />} />
        <Route path="/nl/tours/brugge" element={<BrugesPage />} />
        <Route path="/nl/tours/keukenhof" element={<KeukenhofPage />} />
        <Route path="/nl/tours/marken" element={<MarkenPage />} />
        <Route path="/nl/tours/volendam" element={<VolendamPage />} />
        <Route path="/nl/tours/zaanse-schans" element={<ZaanseSchansPage />} />
        <Route path="/nl/tours/brussel" element={<BrusselsPage />} />
        <Route path="/nl/tours/antwerpen" element={<AntwerpPage />} />
      </Routes>
      <Footer />

      {/* Booking Modal */}
      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <BookingModalProvider>
        <LanguageRouter>
          <ScrollToTop />
          <AppContent />
        </LanguageRouter>
      </BookingModalProvider>
    </Router>
  );
}

export default App;
